module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a9wjZ"))).then(() => parcelRequire('hEqeo'));